export default "__VITE_ASSET__Ze28XZyw__"